<template>
  <div class="progress-step" :class="{ 'completed': stepCompleted }">
    <div class="circle" :class="{ 'completed': stepCompleted }">
      <div class="number" v-if="!stepCompleted">{{ stepNumber }}</div>
      <img class="v-logo" v-else :src="require('@/assets/onboarding/icons/icon-small-check.svg')">
    </div>
    <div class="step-name fs-unmask" :class="{ 'completed': stepCompleted }">{{ stepName }}</div>
  </div>
</template>

<script>

export default {
  name: 'ProgressStep',
  props: {
    stepCompleted: {
      type: Boolean,
      default: false,
    },
    stepNumber: {
      type: String,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .progress-step {
    @include responsive-padding;
    height: 90px;
    width: 100%;
    display: flex;
    align-items: center;

    &.completed {
      background-color: $riseup_v2_light_green;
    }

    .circle {
      display: inline-block;
      height: 40px;
      width: 40px;
      vertical-align: middle;
      text-align: center;
      border-radius: 50%;
      background-color: $riseup_v2_light_blue;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;

      &.completed {
        background-color: #2dc05c;
      }

      .v-logo {
        height: 18px;
      }

      .number {
        font-size: 18px;
        font-weight: bold;
        font-family: SimplerPro;
      }
    }

    .step-name {
      font-size: 18px;
      font-family: SimplerPro;
      line-height: 1.33;

      &.completed {
        font-weight: bold;
      }
    }
  }

</style>
